import { render, staticRenderFns } from "./prod_type43.vue?vue&type=template&id=4865702a&scoped=true"
import script from "./prod_type43.vue?vue&type=script&lang=js"
export * from "./prod_type43.vue?vue&type=script&lang=js"
import style0 from "./prod_type43.vue?vue&type=style&index=0&id=4865702a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4865702a",
  null
  
)

export default component.exports